













































import { AvailableMembershipPlan } from '@/models/api/paid-member-price/member-plan/available-membership-plan'
import FreeAreaService from '@/services/free-area/free-area'
import {
  SelectPaidMembershipPlanFreeArea
} from '@/services/free-area/paid-membership/select-paid-membership-plan-free-area'
import DropdownSelect from '@spa/components/atoms/DropdownSelect.vue'
import DescriptionOfPlans from '@spa/components/organisms/paid-membership/description/DescriptionOfPlans.vue'
import Vue from 'vue'
import { Component, Emit, Prop } from 'vue-property-decorator'

@Component({
  components: {
    DescriptionOfPlans,
    DropdownSelect,
  },
})
export default class SelectPaidMemberPlan extends Vue {
  @Prop({ required: true })
  readonly planList: AvailableMembershipPlan[]

  @Prop({
    default: () => FreeAreaService.createForHost(SelectPaidMembershipPlanFreeArea),
  })
  readonly freeAreaService: SelectPaidMembershipPlanFreeArea

  value: string | null = null

  @Emit('input-plan')
  onInput(value: string) {
    this.value = value

    return value
  }
  @Emit('submit')
  onSubmit() {
    // nothing to do
  }

  get planNeverSelectedYet(): boolean {
    return this.value === null
  }

  get planOptionList() {
    return [
      {
        value: '',
        text: 'プランを選択してください',
        selected: this.value === null,
        disabled: true,
      },
      ...this.planList.map(plan => ({
        value: plan.externalId,
        text: plan.displayLabel,
        selected: false,
        disabled: false,
      })),
    ]
  }
}
